var $38d676b4c811e6ae$exports = {};
// Instantiate TabPanelWidget
Tabpanelwidget.autoinstall();


//# sourceMappingURL=tab.js.map
